
module.exports = function StockLevelInputWidget ($host, config) {

  // Dom
  var $input    = $('[data-text-input]',  $host);
  var $checkbox = $('[data-check-input]', $host);
  var $notLabel = $('span[for]',          $host);

  // Functions
  function setDisabledState (key) {
    $input.attr('disabled', $checkbox.is(':checked'));
  }

  function focusCheckbox () {
    $checkbox.focus().click();
  }

  // Listeners
  $checkbox.on('click', setDisabledState);
  $notLabel.on('click', focusCheckbox);

  // Init
  setDisabledState();
  $notLabel.css('cursor', 'pointer');

  // Interface
  return {
  };

}


